<div class="encoding-dropzone-container" [class.empty]="isEmpty()">
  <div class="header">{{ header }}</div>
  <div class="row-col-btns" *ngIf="chartType === 'vegasPivotTable' && channel === 'value'">
    <button
      (click)="onSwitchNamesAxes()"
      [class.active]="!measureNamesInRow && isChartEncodingComplete"
      [disabled]="!measureNamesInRow || !isChartEncodingComplete"
      data-test="name-to-col"
    >
      <div
        capraTooltip
        [tooltipContent]="tooltipNameColumnContent"
        tooltipPlacement="top"
        [tooltipInteractive]="tooltipInteractive"
        [tooltipDelay]="tooltipDelay"
        [tooltipAppendTo]="tooltipAppendTo"
        tooltipSize="regular-thin"
      >
        <capra-icon class="header-search-icon" icon="icon-column"></capra-icon>
      </div>
    </button>
    <button
      (click)="onSwitchNamesAxes()"
      [class.active]="measureNamesInRow && isChartEncodingComplete"
      [disabled]="measureNamesInRow || !isChartEncodingComplete"
      data-test="name-to-row"
    >
      <div
        capraTooltip
        [tooltipContent]="tooltipNameRowContent"
        tooltipPlacement="top"
        [tooltipInteractive]="tooltipInteractive"
        [tooltipDelay]="tooltipDelay"
        [tooltipAppendTo]="tooltipAppendTo"
        tooltipSize="regular-thin"
      >
        <capra-icon class="header-search-icon" icon="icon-row"></capra-icon>
      </div>
    </button>
  </div>
  <div
    class="field-list"
    [class.empty]="isEmpty()"
    [class.isTypeahead]="isDisplayTypeahead()"
    [class.dragging]="isDraggable"
    [class.values-channel]="channel === 'value'"
    [class.pivot-table]="chartType === 'vegasPivotTable'"
    [class.histogram]="chartType === 'histogram'"
    dndDropzone
    [dndDisableDropIf]="isDisallowedField"
    [dndAllowExternal]="true"
    (dndDrop)="onDropItem($event)"
  >
    <div
      class="placeholder-field"
      [class.continuous-field]="placeholderClasses && (isDragFieldContinuous || isDragFieldGroup)"
      [class.discrete-field]="placeholderClasses && !isDragFieldContinuous && !isDragFieldGroup"
      [class.group-field]="isDragFieldGroup"
      dndPlaceholderRef
    >
      <div class="cursor-left"></div>
      <div class="cursor-right"></div>
    </div>
    <div
      *ngFor="let field of fields; trackBy: trackById"
      class="field"
      [class.field-group]="isEncFieldGroup(field)"
      [class.continuous-field]="isContinuous(field)"
      [class.discrete-field]="isDiscrete(field)"
      [dndDraggable]="field"
      dndEffectAllowed="move"
      (dndStart)="onDragStart($event, field)"
      (dndEnd)="onDragEnd($event, field)"
    >
      <div
        *ngIf="isEncField(field)"
        class="field-dropzone"
        dndDropzone
        [dndDisableDropIf]="!isDragEqualToFieldType(field)"
        [dndAllowExternal]="true"
        (dndDrop)="onFieldDrop($event, field)"
      ></div>
      <ng-container
        [ngTemplateOutlet]="template"
        [ngTemplateOutletContext]="{
          field: field,
          channel: channel,
          modeView: view,
          viewSource: viewSource,
          allowScalars: allowScalars,
          allowDiscrete: allowDiscrete,
          allowContinuous: allowContinuous
        }"
      ></ng-container>
    </div>
    <mode-typeahead-attrs-list
      *ngIf="isDisplayTypeahead()"
      [view]="view"
      [chartType]="chartType"
      [channel]="channel"
      [placeholderText]="placeholderText"
      (attrSelected)="onAttrSelected($event)"
    ></mode-typeahead-attrs-list>
  </div>
</div>
